import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseStatusListResponse,
  IInventoryPurchaseStatusListResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const usePurchaseOrderStatusListAPI = () => {
  const [purchaseOrderStatus, setPurchaseOrderStatus] = useState<IInventoryPurchaseStatusListResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      await axios
        .get(`${INVENTORY_MODULE?.PURCHASE_STATUS_LIST?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryPurchaseStatusListResponse>) => {
          if (res.data.status === true) {
            setPurchaseOrderStatus(res.data.data);
          } else {
            setPurchaseOrderStatus([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      setPurchaseOrderStatus([]);
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError)
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return { execute, purchaseOrderStatus };
};
